import type { CSSProperties } from 'react';
import { cx } from './cx';
import s from './Skeleton.module.css';

export interface SkeletonProps {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  radius?: CSSProperties['borderRadius'];
  className?: string;
}

/** Zone de chargement animée (masquée aux lecteurs d'écran). */
export function Skeleton({ width = '100%', height = 16, radius, className }: SkeletonProps) {
  return <span aria-hidden="true" className={cx(s.sk, className)} style={{ width, height, borderRadius: radius }} />;
}
